
import React from "react";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";

interface FormTextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  description?: string;
  error?: string;
}

export const FormTextarea = React.forwardRef<HTMLTextAreaElement, FormTextareaProps>(
  ({ label, description, error, className, id, ...props }, ref) => {
    const textareaId = id || React.useId();
    
    return (
      <div className="space-y-2 w-full">
        {label && (
          <Label htmlFor={textareaId} className="font-medium text-gray-700">
            {label}
          </Label>
        )}
        <Textarea
          id={textareaId}
          ref={ref}
          className={`min-h-[100px] w-full bg-gray-50 border-heaven-gold/20 text-gray-800 placeholder:text-gray-400 focus-visible:ring-heaven-gold/30 rounded-md ${className || ""}`}
          {...props}
        />
        {description && (
          <p className="text-xs text-gray-500">{description}</p>
        )}
        {error && (
          <p className="text-xs text-red-600">{error}</p>
        )}
      </div>
    );
  }
);

FormTextarea.displayName = "FormTextarea";
